import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import request from "./request";
import personal from "./personal"
import {editVehicle} from "./vehicles"

export default combineReducers({
  auth,
  message,
  request,
  personal,
  editVehicle
});